import { useMemo } from 'react';

import { AuthService } from 'shared/lib/keycloak';
import {
  hasAsset,
  PROGRAMS_ASSETS,
  useIsDistrictAdminUserCheck,
} from 'shared/lib/utils';
import { useGetUserAssetsQuery } from 'shared/api/retail';
import {
  filterAquaUserLicenses,
  useGetAquaUserLicensesQuery,
} from 'shared/api/aqua';

export const useAssets = () => {
  const teacherBk = AuthService.getUserBk();

  const isDistrictAdminUser = useIsDistrictAdminUserCheck();

  const {
    data: rawUserAssets = [],
    isError: isUserAssetsError,
    isLoading: isUserAssetsLoading,
  } = useGetUserAssetsQuery(teacherBk);

  const {
    isLoading: isAquaQueryLoading,
    data: aquaUserLicensesData,
    isError: isAquaQueryError,
  } = useGetAquaUserLicensesQuery(undefined, {
    skip: !isDistrictAdminUser,
  });

  const isError = isUserAssetsError || isAquaQueryError;
  const isLoading = isUserAssetsLoading || isAquaQueryLoading;

  const allAssets = useMemo(() => {
    const hasBoostReadingAsset = hasAsset(
      PROGRAMS_ASSETS.BoostReadingAqua,
      rawUserAssets,
    );
    const hasBoostLecturaAsset = hasAsset(
      PROGRAMS_ASSETS.BoostLectura,
      rawUserAssets,
    );

    const relevantAquaUserLicenses = filterAquaUserLicenses({
      aquaUserLicenses: aquaUserLicensesData?.transformedResponse,
      hasBoostLecturaAssetInRetail: hasBoostLecturaAsset,
      hasBoostReadingAssetInRetail: hasBoostReadingAsset,
    });

    return [...rawUserAssets, ...relevantAquaUserLicenses];
  }, [aquaUserLicensesData, rawUserAssets]);

  return {
    userAssets: allAssets,
    rawUserAssets,
    isLoading,
    isError,
  };
};
